import { render, staticRenderFns } from "./DeliveryHistory.vue?vue&type=template&id=061c87aa"
import script from "./DeliveryHistory.vue?vue&type=script&lang=js"
export * from "./DeliveryHistory.vue?vue&type=script&lang=js"
import style0 from "./DeliveryHistory.vue?vue&type=style&index=0&id=061c87aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports